/** 本地日期，YYYY-MM-DD，無時區資訊（data-model 2.1）。 */
export type LocalDate = string;

const LOCAL_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

function pad2(value: number): string {
  return value.toString().padStart(2, '0');
}

/** 以裝置本地日曆日輸出，不可改用 toISOString，那會在午夜前後跨日。 */
export function toLocalDate(date: Date): LocalDate {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function todayLocalDate(now: Date = new Date()): LocalDate {
  return toLocalDate(now);
}

export function isValidLocalDate(value: unknown): value is LocalDate {
  if (typeof value !== 'string') return false;
  const match = LOCAL_DATE_PATTERN.exec(value);
  if (!match) return false;

  const [, year, month, day] = match;
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  const parsed = new Date(y, m - 1, d);
  return parsed.getFullYear() === y && parsed.getMonth() === m - 1 && parsed.getDate() === d;
}

function toUtcNoon(value: LocalDate): number {
  const [year, month, day] = value.split('-').map(Number);
  // 用 UTC 正午避開日光節約時間造成的 23／25 小時日。
  return Date.UTC(year ?? 0, (month ?? 1) - 1, day ?? 1, 12);
}

/** target 減 base 的日曆日差；未來為正、過去為負。 */
export function differenceInLocalDays(target: LocalDate, base: LocalDate): number {
  const diffMs = toUtcNoon(target) - toUtcNoon(base);
  return Math.round(diffMs / 86_400_000);
}
